module.exports = __webpack_public_path__ + "static/media/cny_1.3de0c387.jpg";